'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['network'],
    data: function data() {
        return {
            error_message: ''
        };
    },
    computed: {
        modeString: function modeString() {
            var str = '';
            this.network.ircClient.user.modes.forEach(function (mode) {
                str += mode;
            });

            if (str) {
                str = '+' + str;
            }

            return str;
        },
        netUser: function netUser() {
            return this.network.ircClient.user;
        }
    },
    created: function created() {
        var _this = this;

        this.listen(this.network.ircClient, 'nick in use', function (event) {
            _this.error_message = 'The nickname \'' + event.nick + '\' is already in use!';
        });
    },

    methods: {
        changeNick: function changeNick(newNick) {
            this.error_message = '';

            var nick = newNick.trim();
            if (!nick.match(/(^[0-9])|(\s)/)) {
                this.network.ircClient.changeNick(newNick);
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SelfUser"]
window._kiwi_exports.components.SelfUser = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SelfUser.vue
// module id = cC0S
// module chunks = 1